import React, { useState, createContext, Dispatch, SetStateAction } from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import TabControl from 'components/atoms/TabControl';
import HolidayManagementSpecialHolidayForm from './HolidayManagementSpecialHolidayForm/HolidayManagementSpecialHolidayForm';
import HolidayManagementRestForm from './HolidayManagementRestForm/HolidayManagementRestForm';
import HolidayManagementPaidForm from './HolidayManagementPaidForm/HolidayManagementPaidForm';
import HolidayManagementHolidayForm from './HolidayManagementHolidayForm/HolidayManagementHolidayForm';
import { useHolidayManagementDomainForm } from './hooks';
import BlockUI from "components/molecules/BlockUi";
import { css } from '@emotion/core';
import HolidayManagementNursingCareForm from './HolidayManagementNursingCareForm';
import FormHeader from 'components/templates/FormHeader';

type SelectType = 'paid' | 'specialHoliday' | 'holiday' | 'rest' | 'nursingCare';

const SelectType: { [key in SelectType]: SelectType } = {
  paid: 'paid',
  specialHoliday: 'specialHoliday',
  holiday: 'holiday',
  rest: 'rest',
  nursingCare: 'nursingCare',
};

//Context global variable
type contextType = {
  isLoading: boolean,
  setIsLoading: Dispatch<SetStateAction<boolean>>
};

export const HolidayManagementContext = createContext<contextType>(
  {} as contextType
);

const HolidayManagementForm: React.FC = () => {
  const {
    arrGrantResult,
    orgTreesOptions,
    employmentOptions,
    specialHolidayOptions,
  } = useHolidayManagementDomainForm();
  //
  const [selectType, setSelectType] = React.useState<SelectType>(SelectType.paid);
  const [currentAccordionList, setCurrentAccordionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    // eslint-disable-next-line react/jsx-fragments
    <HolidayManagementContext.Provider
      value={{
        isLoading,
        setIsLoading
      }}
    >
      <BlockUI blocking={isLoading}>
      <FormHeader title="休暇実績" customStyle={css({ marginTop:'0'})}/>
        <FormContents customStyle={css({marginTop:'60px'})}>
          <div style={{paddingTop: '8px'}}>
          <TabControl
              items={[
                {
                  value: SelectType.paid,
                  display: '有給',
                },
                {
                  value: SelectType.specialHoliday,
                  display: '特休',
                },
                {
                  value: SelectType.holiday,
                  display: '代休',
                },
                {
                  value: SelectType.rest,
                  display: '振休',
                },
                {
                  value: SelectType.nursingCare,
                  display: '介護・看護',
                },
              ]}
              setValue={setSelectType as (arg: string) => void}
              currentValue={selectType}
            />
          </div>
         
          <div style ={{padding: '16px 15px'}}>
            {/* 有給・管理情報 */}
            {selectType === SelectType.paid
              && (
                <HolidayManagementPaidForm
                  arrGrantResult={arrGrantResult}
                  orgTreesOptions={orgTreesOptions}
                  employmentOptions={employmentOptions}
                  currentAccordionList={currentAccordionList}
                  setCurrentAccordionList={setCurrentAccordionList}
                />
              )}
            {/* 特休・管理情報 */}
            {selectType === SelectType.specialHoliday
              && (
                <HolidayManagementSpecialHolidayForm
                  arrGrantResult={arrGrantResult}
                  orgTreesOptions={orgTreesOptions}
                  employmentOptions={employmentOptions}
                  specialHolidayOptions={specialHolidayOptions}
                  currentAccordionList={currentAccordionList}
                  setCurrentAccordionList={setCurrentAccordionList}
                />
              )}

            {/* 代休・取得状況 */}
            {selectType === SelectType.holiday
              && (
                <HolidayManagementHolidayForm orgTreesOptions={orgTreesOptions} />
              )}

            {/* 振休・取得状況 */}
            {selectType === SelectType.rest
              && (
                <HolidayManagementRestForm orgTreesOptions={orgTreesOptions} />
              )}

            {/* 振休・取得状況 */}
            {selectType === SelectType.nursingCare
              && (
                <HolidayManagementNursingCareForm
                  arrGrantResult={arrGrantResult}
                  orgTreesOptions={orgTreesOptions}
                  employmentOptions={employmentOptions}
                  currentAccordionList={currentAccordionList}
                  setCurrentAccordionList={setCurrentAccordionList}
                />
              )}
          </div>
          
        </FormContents>
      </BlockUI>
    </HolidayManagementContext.Provider>
  );
};

export default HolidayManagementForm;
